export default {
  sm: '0.3125rem',
  md: '0.625rem',
  base: '0.625rem',
  default: '0.625rem',
  lg: '1rem',
  xl: '1.63rem',
};
